import { GENDER } from "core/consts";
import { ValueOf } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { padding, sizing } from "ds_legacy/materials/metrics";
import { FONT_SIZE_14, FONT_WEIGHT_BOLD } from "ds_legacy/materials/typography";
import {
  DatePickerWithLabel,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionTwo = () => {
  const translations = useTranslations();

  const options: RadioOptionV2<ValueOf<typeof GENDER>>[] = [
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.male,
      value: GENDER.MALE,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.female,
      value: GENDER.FEMALE,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.diverse,
      value: GENDER.DIVERSE,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.unknown,
      value: GENDER.UNSPECIFIED,
    },
  ];

  return (
    <Section title={translations.patientForms.drvGeneralForm.sectionTwo.title}>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          bold
          elementName="patient_first_name"
          label={translations.patientForms.drvGeneralForm.sectionTwo.firstName}
          large
        />
        <TextInputWithLabel
          bold
          elementName="patient_last_name"
          label={translations.patientForms.drvGeneralForm.sectionTwo.lastName}
          large
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="patient_birth_name"
          label={translations.patientForms.drvGeneralForm.sectionTwo.maidenName}
          large
        />
        <TextInputWithLabel
          bold
          elementName="patient_maiden_name"
          label={
            translations.patientForms.drvGeneralForm.sectionTwo.formerNames
          }
          large
        />
      </SectionRow>
      <SectionRow>
        <RadioGroupV2
          elementName="gender_extended"
          formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
          formLabelSx={{
            fontSize: FONT_SIZE_14,
            fontWeight: FONT_WEIGHT_BOLD,
            padding: padding(1, 0),
          }}
          label={translations.patientForms.drvGeneralForm.sectionTwo.gender}
          options={options}
          radioSx={RADIO_WHITE_BACKGROUND}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="patient_street_housenumber"
          label={translations.patientForms.drvGeneralForm.sectionTwo.street}
          large
        />
        <TextInputWithLabel
          bold
          elementName="patient_zipcode"
          label={translations.patientForms.drvGeneralForm.sectionTwo.zipCode}
        />
        <TextInputWithLabel
          bold
          elementName="patient_city"
          label={translations.patientForms.drvGeneralForm.sectionTwo.city}
          large
        />
      </SectionRow>
      <SectionRow>
        <DatePickerWithLabel
          bold
          elementName="patient_birthdate"
          label={
            translations.patientForms.drvMedicalForm.sectionZero
              .dateBirthPatient
          }
        />
        <TextInputWithLabel
          bold
          elementName="patient_phone_number"
          label={translations.patientForms.drvGeneralForm.sectionTwo.phone}
        />
        <TextInputWithLabel
          bold
          elementName="patient_nationality"
          label={
            translations.patientForms.drvGeneralForm.sectionTwo.nationality
          }
          large
        />
      </SectionRow>
    </Section>
  );
};
